(function () {
  function updateProgress(step) {
    var steps = document.querySelectorAll('[data-cmap-step]');
    steps.forEach(function (item) {
      var itemStep = Number(item.getAttribute('data-cmap-step'));
      item.classList.toggle('is-active', itemStep === step);
      item.classList.toggle('is-complete', itemStep < step);
    });
    updateGuidance(step);
  }

  function updateGuidance(step) {
    var hub = document.querySelector('.custom-maps-hub');
    var title = document.querySelector('[data-cmap-guidance-title]');
    var copy = document.querySelector('[data-cmap-guidance-copy]');
    var guidance = {
      1: ['Start by finding your location', 'Search by postcode, town, village or place name to centre your map.'],
      2: ['Choose your map area', 'Drag the selection area to position your map, then use the corner handles to adjust the coverage.'],
      3: ['Complete your map details', 'Enter your wall size, choose your wallpaper material and add your design brief.'],
      4: ['Review & checkout', 'Check your details and price, then continue to checkout when you are ready.']
    }[step];
    if (hub && hub.dataset.mobileLocationConfirmed === 'true') {
      guidance = hub.dataset.cropReady === 'true'
        ? ['Choose your map area', "Drag and zoom the map to position the area you'd like on your wallpaper."]
        : ['Explore your location', 'Enter your wall size to set the crop area.'];
      var mobileNote = hub.querySelector('.order-map .cmap-mobile-guidance');
      if (mobileNote) {
        mobileNote.querySelector('strong').textContent = guidance[0];
        mobileNote.querySelector('span').textContent = guidance[1];
      }
    }

    if (!guidance) return;
    if (title) title.textContent = guidance[0];
    if (copy) copy.textContent = guidance[1];
    var panel = document.querySelector('[data-cmap-guidance]');
    if (panel) panel.classList.toggle('is-active', step === 2);
  }

  function chooseMapStyle(button, shouldScroll) {
    var card = button.closest('.custom-maps-hub__selector-card');
    if (!card) return;

    document.querySelectorAll('.custom-maps-hub__selector-card').forEach(function (item) {
      item.classList.remove('is-selected');
    });
    card.classList.add('is-selected');

    var mapType = card.getAttribute('data-map-type');
    var mapName = card.getAttribute('data-map-name');
    var mapTypeSelect = document.getElementById('selTM');
    var selectedName = document.querySelector('[data-cmap-selected-style]');
    var mapStyleInput = document.getElementById('cmap-style-name');

    if (mapTypeSelect && mapType) {
      mapTypeSelect.value = mapType;
      mapTypeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      if (typeof SearchPC === 'function') SearchPC();
    }
    if (selectedName) selectedName.textContent = mapName;
    if (mapStyleInput) mapStyleInput.value = mapName;

    updateProgress(1);
    var builder = document.getElementById('map-builder');
    if (builder && shouldScroll !== false) builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function alignMapPreviewWithPrice() {
    var hub = document.querySelector('.custom-maps-hub');
    var stage = hub && hub.querySelector('.custom-maps-hub__map-stage');
    var priceBox = hub && hub.querySelector('.cmap-price-box');
    var desktop = window.matchMedia('(min-width: 1200px)');
    if (!stage || !priceBox) return;

    var frame;
    function sync() {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(function () {
        if (!desktop.matches) {
          stage.style.removeProperty('--cmap-map-height');
          return;
        }

        var height = Math.round(priceBox.getBoundingClientRect().bottom - stage.getBoundingClientRect().top);
        if (height > 280) {
          stage.style.setProperty('--cmap-map-height', height + 'px');
          if (typeof osMap !== 'undefined' && typeof osMap.updateSize === 'function') osMap.updateSize();
        }
      });
    }

    if (window.ResizeObserver) {
      var observer = new ResizeObserver(sync);
      observer.observe(priceBox);
      observer.observe(priceBox.parentElement);
    }
    window.addEventListener('resize', sync);
    desktop.addEventListener('change', sync);
    sync();
  }

  function fitMapSelectionOnMobile() {
    var mobile = window.matchMedia('(max-width: 620px)');
    var stage = document.querySelector('.custom-maps-hub__map-stage');
    if (!stage || !mobile.matches || !window.IntersectionObserver) return;

    function fitSelection() {
      if (!mobile.matches || typeof osMap === 'undefined' || !osMap || typeof osMap.zoomToExtent !== 'function') return;
      // unsetFeature leaves a placeholder geometry; only fit a real mural crop.
      if (typeof currentBounds === 'undefined' || !currentBounds || typeof cmapGetMapDimensions !== 'function' || !cmapGetMapDimensions()) return;
      if (typeof transform === 'undefined' || !transform || !transform.box || !transform.box.geometry) return;

      var bounds = currentBounds;
      if (!bounds) return;

      if (typeof osMap.updateSize === 'function') osMap.updateSize();
      osMap.zoomToExtent(bounds, false);
    }

    var mapObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        window.setTimeout(fitSelection, 150);
      });
    }, { threshold: 0.35 });

    mapObserver.observe(stage);
  }

  function init() {
    var hub = document.querySelector('.custom-maps-hub');
    document.addEventListener('cmap:location-selection', function (event) {
      if (hub) hub.dataset.mobileLocationConfirmed = String(Boolean(event.detail && event.detail.confirmed));
      updateMobileMapStage();
      updateGuidance(1);
    });
    document.addEventListener('cmap:crop-readiness', function (event) {
      if (hub) hub.dataset.cropReady = String(Boolean(event.detail && event.detail.ready));
      updateGuidance(1);
    });
    alignMapPreviewWithPrice();
    // The hub frame is screen-anchored; fitting geographic bounds would undo zoom.
    var checkoutBox = document.querySelector('.custom-maps-hub .cmap-btn-box');
    var mapSelector = document.querySelector('.custom-maps-hub .order-map');
    if (checkoutBox && mapSelector) {
      var checkoutHome = document.createComment('Checkout desktop position');
      checkoutBox.before(checkoutHome);
      var mobileCheckout = window.matchMedia('(max-width: 989px)');
      function positionCheckout() {
        if (mobileCheckout.matches) mapSelector.after(checkoutBox);
        else checkoutHome.after(checkoutBox);
      }
      mobileCheckout.addEventListener('change', positionCheckout);
      positionCheckout();
    }
    document.querySelectorAll('[data-cmap-choose]').forEach(function (button) {
      button.addEventListener('click', function () { chooseMapStyle(button); });
    });

    document.querySelectorAll('.custom-maps-hub__selector-card').forEach(function (card) {
      card.addEventListener('click', function (event) {
        if (event.target.closest('a, button')) return;
        chooseMapStyle(card.querySelector('[data-cmap-choose]'));
      });
    });

    var location = document.getElementById('inpPostCodChange');
    if (location) location.addEventListener('input', function () {
      if (hub) hub.dataset.mobileLocationConfirmed = 'false';
      updateMobileMapStage();
    });
    var width = document.getElementById('inpWi');
    var height = document.getElementById('inpHe');
    var material = document.getElementById('map_var');
    var request = document.getElementById('crequest');
    var mapReference = document.getElementById('inpFrmIN');
    var mapArea = document.getElementById('map_container');
    var mapAdjusted = false;
    var checkoutReady = false;

    function updateMobileMapStage() {
      if (!hub) return;
      var ready = hub.dataset.mobileLocationConfirmed === 'true';
      var wasReady = hub.dataset.mobileMapReady === 'true';
      hub.dataset.mobileMapReady = String(ready);
      if (ready && !wasReady && window.matchMedia('(max-width: 989px)').matches) {
        window.requestAnimationFrame(function () {
          if (typeof osMap !== 'undefined' && osMap && typeof osMap.updateSize === 'function') osMap.updateSize();
        });
      }
    }

    function locationSelected() {
      return Boolean(hub && hub.dataset.mobileLocationConfirmed === 'true');
    }

    function refreshProgress() {
      var hasDimensions = Boolean(width && height && width.value && height.value);
      var checkoutButton = document.querySelector('#order .btnaddtocart');
      if (checkoutButton) checkoutReady = !checkoutButton.disabled && checkoutButton.getAttribute('aria-disabled') !== 'true';
      if (checkoutReady) return updateProgress(4);
      if (locationSelected() && (mapAdjusted || hasDimensions)) return updateProgress(3);
      if (locationSelected()) return updateProgress(2);
      updateProgress(1);
    }

    document.addEventListener('cmap:checkout-readiness', function (event) {
      checkoutReady = Boolean(event.detail && event.detail.canContinue);
      updateMobileMapStage();
      refreshProgress();
    });

    [location, width, height, material, request].filter(Boolean).forEach(function (field) {
      field.addEventListener('input', refreshProgress);
      field.addEventListener('change', refreshProgress);
    });
    if (mapArea) {
      mapArea.addEventListener('pointerdown', function () {
        if (locationSelected()) {
          mapAdjusted = true;
          refreshProgress();
        }
      }, true);
    }
    window.setInterval(refreshProgress, 400);
    refreshProgress();

    var requestedMapType = new URLSearchParams(window.location.search).get('map');
    var returnPath = new URLSearchParams(window.location.search).get('return_to');
    var returnLabel = new URLSearchParams(window.location.search).get('return_label');
    var returnLink = document.querySelector('[data-cmap-return]');
    if (returnLink && returnPath && /^\/products\/[a-z0-9-]+\/?$/i.test(returnPath)) {
      returnLink.href = returnPath;
      returnLink.lastChild.textContent = ' Back to ' + (returnLabel || 'map style');
      returnLink.hidden = false;
    }
    if (requestedMapType) {
      var requestedCard = document.querySelector('.custom-maps-hub__selector-card[data-map-type="' + requestedMapType + '"]');
      if (requestedCard) {
        chooseMapStyle(requestedCard.querySelector('[data-cmap-choose]'), window.location.hash !== '#map-selector');
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
